import { Link } from "react-router-dom";

export function LegalPage({ title, subtitle, effectiveDate, dateLabel = "Effective date", children, testId }) {
  return (
    <div className="bg-[#f8fafc]" data-testid={testId}>
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
          <Link
            to="/"
            className="text-sm font-medium text-blue-700 hover:text-blue-800 transition-colors"
            data-testid="legal-back-home"
          >
            ← Back to home
          </Link>
          <h1 className="mt-6 text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
              {subtitle}
            </p>
          )}
          {effectiveDate && (
            <p className="mt-6 text-sm text-slate-500">
              {dateLabel}: <span className="font-medium text-slate-700">{effectiveDate}</span>
            </p>
          )}
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-16">
        <div className="space-y-10">{children}</div>
      </div>
    </div>
  );
}

export function LegalSubheading({ children }) {
  return (
    <h3 className="text-base sm:text-lg font-semibold text-slate-800 pt-2">
      {children}
    </h3>
  );
}

export function LegalSection({ title, children, highlight = false }) {
  return (
    <section
      className={
        highlight
          ? "rounded-2xl border border-blue-200 bg-blue-50/60 p-7 sm:p-8"
          : ""
      }
    >
      <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-slate-900">
        {title}
      </h2>
      <div className="mt-4 space-y-4 text-[15px] leading-relaxed text-slate-600">
        {children}
      </div>
    </section>
  );
}
